export const sourcelist = [
  {
    id: "source14",
    cx: 903.5,
    cy: 161.5,
    r: 84,
    tx: 850.8221,
    ty: 156.2643,
    content: `<tspan x="0" y="0">Reproductive Health </tspan><tspan x="22.55" y="14">Interchange</tspan>`
  },
  {
    id: "source18",
    cx: 701.5,
    cy: 55.5,
    r: 52,
    tx: 690.773,
    ty: 44.3222,
    content: `<tspan x="0" y="0">NIDI </tspan><tspan x="-13.69" y="14">Resource </tspan><tspan x="-3.84" y="28">Flows</tspan>`
  },
  {
    id: "source13",
    cx: 623,
    cy: 202,
    r: 94.5,
    tx: 592.0888,
    ty: 198.2217,
    content: `<tspan x="0" y="0">Adding It Up </tspan><tspan x="13.83" y="14">Report</tspan>`
  },
  {
    id: "source7",
    cx: 402.5,
    cy: 59.5,
    r: 55,
    tx: 360.8544,
    ty: 55.7219,
    content: `<tspan x="0" y="0">Social Marketing </tspan><tspan x="18.62" y="14">Statistics</tspan>`
  },
  {
    id: "source8",
    cx: 446.5,
    cy: 161.5,
    r: 79,
    tx: 407.3566,
    ty: 150.722,
    content: `<tspan x="0" y="0">MSI, PSI, &amp; DKT </tspan><tspan x="-3.34" y="14">Service Statistics </tspan><tspan x="2.09" y="28">and Sales Data</tspan>`
  },
  {
    id: "source4",
    cx: 269,
    cy: 142,
    r: 77.5,
    tx: 256.4301,
    ty: 145.222,
    content: `MICS`
  },
  {
    id: "source2",
    cx: 146,
    cy: 240,
    r: 100,
    tx: 104.0663,
    ty: 229.222,
    content: `<tspan x="0" y="0">UNPD Estimates </tspan><tspan x="2.62" y="14">and Projections </tspan><tspan x="2.87" y="28">of FP Indicators</tspan>`
  },
  {
    id: "source21",
    cx: 980.5,
    cy: 286.5,
    r: 100,
    tx: 938.0089,
    ty: 282.522,
    content: `<tspan x="0" y="0">CGA Estimates of </tspan><tspan x="-6.52" y="14">Consumption Costs</tspan>`
  },
  {
    id: "source5",
    cx: 336,
    cy: 268,
    r: 85.5,
    tx: 325.1941,
    ty: 271.2217,
    content: `DHS`
  },
  {
    id: "source1",
    cx: 80,
    cy: 360,
    r: 80,
    tx: 60.5126,
    ty: 356.2217,
    content: `<tspan x="0" y="0">FP2020 </tspan><tspan x="-20.63" y="14">Progress Report</tspan>`
  },
  {
    id: "source3",
    cx: 213,
    cy: 331,
    r: 73,
    tx: 170.6586,
    ty: 334.222,
    content: `National Surveys`
  },
  {
    id: "source19",
    cx: 736,
    cy: 151,
    r: 70.5,
    tx: 692.6083,
    ty: 139.8218,
    content: `<tspan x="0" y="0">UNFPA Report on </tspan><tspan x="10.84" y="14">Government </tspan><tspan x="19.49" y="28">Spending</tspan>`
  },
  {
    id: "source12",
    cx: 570,
    cy: 96,
    r: 48.5,
    tx: 548.8088,
    ty: 85.2217,
    content: `<tspan x="0" y="0">Track20 </tspan><tspan x="-7.9" y="14">M&amp;E Officer </tspan><tspan x="-14.1" y="28">Retail Surveys</tspan>`
  },
  {
    id: "source11",
    cx: 547.5,
    cy: 168.5,
    r: 43,
    tx: 524.1726,
    ty: 171.7217,
    content: `FP Watch`
  },
  {
    id: "source9",
    cx: 502,
    cy: 261,
    r: 76.5,
    tx: 459.8924,
    ty: 264.2221,
    content: `IQVIA Retail Data`
  },
  {
    id: "source10",
    cx: 536.5,
    cy: 331.5,
    r: 40,
    tx: 505.696,
    ty: 320.7217,
    content: `<tspan x="0" y="0">SHOPS Plus </tspan><tspan x="-5.66" y="14">Private Sector </tspan><tspan x="-1.27" y="28">Assessments</tspan>`
  },
  {
    id: "source6",
    cx: 380,
    cy: 332,
    r: 45.5,
    tx: 357.1217,
    ty: 335.7923,
    content: `PMA2020`
  },
  {
    id: "source20",
    cx: 769,
    cy: 253,
    r: 71.5,
    tx: 732.3829,
    ty: 241.822,
    content: `<tspan x="0" y="0">Contraceptive </tspan><tspan x="16.05" y="14">Security </tspan><tspan x="11.32" y="28">Indicators</tspan>`
  },
  {
    id: "source17",
    cx: 681,
    cy: 286,
    r: 41.5,
    tx: 661.0079,
    ty: 275.2221,
    content: `<tspan x="0" y="0">Track20 </tspan><tspan x="-11.47" y="14">FP Spending </tspan><tspan x="-12.08" y="28">Assessments</tspan>`
  },
  {
    id: "source16",
    cx: 669,
    cy: 363,
    r: 46.5,
    tx: 644.2384,
    ty: 352.2217,
    content: `<tspan x="0" y="0">RHSC LAC </tspan><tspan x="3.43" y="14">Country </tspan><tspan x="7.63" y="28">Survey</tspan>`
  },
  {
    id: "source15",
    cx: 825,
    cy: 372,
    r: 90.5,
    tx: 785.6653,
    ty: 368.222,
    content: `<tspan x="0" y="0">UNFPA External </tspan><tspan x="-14.51" y="14">Procurement Reports</tspan>`
  }
];
